<!-- 项目选择-详情 -->
<template>
  <div class="choose-detail">
    <div class="choose-detail-title">
      <h1>{{detail.title}}</h1>
      <p>{{detail.sendTime | filterTime}}</p>
    </div>
    <!-- 申请意向参考 -->
    <intention-consult :univerList="univerList"
                       :tabColumns="tabColumns"
                       ref="intentionConsult"
                       :hasFeedback="detail.hasFeedback"
                       @on-change-intention="handleIntention"></intention-consult>
    <!-- 申请意向的学校 -->
    <intention-school @on-change="$refs['intentionConsult'].handleSearch()"
                      ref="intentionSchool"
                      type="preview"
                      :tabColumns="tabColumns"
                      :hasFeedback="detail.hasFeedback"></intention-school>
    <!-- 申请意向  -->
    <intention-fill type="preview"
                    v-if="!detail.hasFeedback"></intention-fill>
    <!-- 申请意向回显 -->
    <intention-detail type="preview"
                      v-else></intention-detail>
    <!-- 查看项目特点 -->
    <project-characteristic2 ref="projectCharacteristic"></project-characteristic2>
  </div>
</template>

<script>
// API
import { getPreviewItemDetail, getPreviewItemList, getItemPurposeModify } from '@/api/preproject'
import dayjs from 'dayjs'
import { tabColumns } from './common'
// components
import IntentionConsult from './intention-consult'
import IntentionSchool from './intention-school'
import IntentionFill from './intention-fill'
import IntentionDetail from './intention-detail'
import ProjectCharacteristic2 from './project-characteristic2'
export default {
  name: 'project-choose-detail',
  components: {
    IntentionConsult,
    IntentionSchool,
    IntentionFill,
    IntentionDetail,
    ProjectCharacteristic2
  },
  data () {
    return {
      id: this.$route.query.id,
      detail: {},
      univerList: [],
      tabColumns: []
    }
  },
  computed: {},
  mounted () {
    this.getDetail()
  },
  methods: {
    // 获取列表
    getPageList (data) {
      return new Promise((resolve, reject) => {
        getPreviewItemList(data).then(res => {
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 获取详情
    getDetail () {
      getPreviewItemDetail({
        id: this.id
      }).then(res => {
        this.detail = res.data.model
        this.tabColumns = [
          {
            title: '序号',
            type: 'index',
            width: 65,
            fixed: 'left',
            align: 'center'
          },
          {
            title: '学校',
            key: 'univer',
            width: 160,
            fixed: 'left',
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.overseasBasicInfo.univer)
            }
          },
          {
            title: '项目',
            key: 'name',
            width: 250,
            fixed: 'left',
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.overseasBasicInfo.name)
            }
          },
          ...tabColumns(res.data.model, this)
        ]
      })
    },
    // 点击申请意向
    handleIntention (data) {
      getItemPurposeModify(data).then(res => {
        this.$refs['intentionConsult'].getPageList()
        this.$refs['intentionSchool'].getPageList()
      }).catch((error) => {
        this.$Message.error(error.message)
      })
    }
  },
  filters: {
    filterTime (value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang='less' scoped>
</style>
